import { isEqual } from 'lodash';
import { DateTime } from 'luxon';

import constants from '~/utils/constants';

import { addActiveRequest, removeActiveRequest } from '../loadTasksSlice';

export const getRouteDate = ({
    routeDate,
    getState
}: {
    routeDate?: string;
    getState: () => {
        selectedDate?: string;
    };
}): string | undefined | null => {
    if (routeDate) return routeDate;

    const { selectedDate } = getState();
    return selectedDate;
};

export const addActiveTasksRequest = ({
    dispatch,
    getState,
    newRequestId,
    newState,
    isRequestIdsMustMatch = true
}: {
    dispatch: (action: unknown) => void;
    getState: () => {
        loadTasks: { requestId: string };
    };
    newRequestId: string;
    newState: unknown;
    isRequestIdsMustMatch?: boolean;
}): void => {
    const {
        loadTasks: { requestId }
    } = getState();

    if (!isRequestIdsMustMatch || requestId === newRequestId)
        dispatch(addActiveRequest(newState));
};

export const removeActiveTasksRequest = ({
    dispatch,
    activeRequestId
}: {
    dispatch: (action: unknown) => void;
    activeRequestId: string;
}): void => {
    dispatch(removeActiveRequest(activeRequestId));
};

export const isFetchAllTasksAllowed = (
    {
        limit,
        status,
        selectedClientIds,
        routeDate: routeDateProp
    }: {
        limit?: number;
        status?: unknown;
        selectedClientIds?: string[];
        routeDate: string;
    },
    {
        getState
    }: {
        getState: () => {
            selectedDate?: string;
            loadTasks: {
                [key: string]: {
                    lastFetchMilliseconds?: number;
                    requestProps: unknown[];
                    requestId: string;
                };
            };
        };
    }
): boolean => {
    const routeDate = getRouteDate({
        getState,
        routeDate: routeDateProp
    });
    const { loadTasks } = getState();

    const newLoadTaskProps = [routeDate, status, limit, selectedClientIds];

    const activeRequests = Object.values(loadTasks).filter((request) => {
        const isActiveRequest = Boolean(request.requestId);
        const hasSameProps = isEqual(newLoadTaskProps, request.requestProps);
        return isActiveRequest && hasSameProps;
    });

    if (activeRequests.length > 0) return false;

    const mostRecentRequest = Object.values(loadTasks)
        .filter((request) => isEqual(newLoadTaskProps, request.requestProps))
        .sort(
            (a, b) =>
                (b.lastFetchMilliseconds || 0) - (a.lastFetchMilliseconds || 0)
        )[0];

    if (!mostRecentRequest) return true;

    const currentTimeMilliseconds = DateTime.local().toMillis();
    const expirationMilliseconds =
        (mostRecentRequest.lastFetchMilliseconds || 0) +
        constants.timings.IGNORE_DUPLICATE_FETCH;

    return currentTimeMilliseconds > expirationMilliseconds;
};
